import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormErrorService {
  getUsernameInputError(formControl: AbstractControl) {
    if (formControl.hasError('hasWhitespace')) {
      return 'Username cannot include whitespace';
    }
    if (formControl.hasError('pattern')) {
      return 'Username can only contain alphanumeric characters (no special characters or spaces)';
    }
    if (formControl.hasError('hasEmoji')) {
      return 'Username cannot include emoji.';
    }
    if (formControl.hasError('minlength')) {
      return 'Username should be at least 6 characters long';
    }
    if (formControl.hasError('maxlength')) {
      return 'Username cannot be longer than 25 characters';
    }
    return '';
  }

  getPasswordInputError(formControl: AbstractControl) {
    if (formControl.hasError('minlength')) {
      return 'Password should be at least 8 characters long';
    }
    return '';
  }

  getPasswordCriteriaError(formControl: AbstractControl) {
    if (
      formControl.hasError('minlength') ||
      formControl.hasError('hasWhiteSpace') ||
      formControl.hasError('hasCapitalCase') ||
      formControl.hasError('hasSmallCase') ||
      formControl.hasError('hasNumeric') ||
      formControl.hasError('hasSpecialCharacters')
    ) {
      return 'Please ensure password meets specified criteria';
    }
    return '';
  }

  getPasswordMismatchError(formControl: AbstractControl) {
    if (formControl.hasError('PasswordMismatch')) {
      return 'Your password and confirmation password do not match';
    }
    return '';
  }

  getLastNameInputError(formControl: AbstractControl) {
    if (formControl.hasError('maxlength')) {
      return 'Reached name length limit';
    }
    if (formControl.hasError('pattern')) {
      return 'Invalid characters';
    }
    return '';
  }

  getSsnInputError(formControl: AbstractControl) {
    if (formControl.hasError('minlength')) {
      return 'Please enter the last six digits of your SSN';
    }
    return '';
  }

  getDateOfBirthInputError(formControl: AbstractControl) {
    if (formControl.hasError('invalidDateOfBirthFormat')) {
      return 'Please enter a valid date';
    }
    if (formControl.hasError('invalidDateOfBirthRange')) {
      return 'Please enter a date in valid range';
    }
    return '';
  }

  getContactMethodValueInputError(formControl: AbstractControl) {
    if (formControl.hasError('invalidPhoneOrEmailFormat')) {
      return 'Please enter a valid email or phone.';
    }
    return '';
  }
}
